import * as ng from 'angular';

export class PaypalCancelController implements ng.IController {

    static $inject: string[] = [];

    constructor(
    ) {
        // ?
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/registration/paypal-cancel/paypal-cancel.controller.ts